import PropTypes from 'prop-types';
import { FormControl, InputLabel, MenuItem, Select as SelectMUI, FormHelperText } from '@mui/material';

import * as Styled from './Select.styles';

export const Select = ({ onChange = () => {}, label, value, error, options = [], disabled }) => {
  return (
    <Styled.Wrapper>
      <FormControl fullWidth error={!!error}>
        <InputLabel>{label}</InputLabel>
        <SelectMUI value={value || ''} label={label} onChange={(event) => onChange(event.target.value)} disabled={disabled}>
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </SelectMUI>
        {error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    </Styled.Wrapper>
  );
};

Select.propTypes = {
  options: PropTypes.array,
  onChange: PropTypes.func,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
};
